import { combineReducers } from 'redux';
import * as pageReducers from './containers/reducers';
import { hostedAssets } from './containers/reducers';
import rootDuckReducer from './ducks/rootDuckReducer';

/**
 * Function _createReducer_ combines global reducers (reducers that are used in
 * multiple pages) and reducers that are handling actions happening inside one page container.
 * Since we combineReducers, pageReducers will get page specific key (e.g. SearchPage)
 * which is page specific.
 * Future: this structure could take in asyncReducers, which are changed when you navigate pages.
 */
const _appReducer = combineReducers({
  ...pageReducers,
  hostedAssets,
});

const createReducer = () => (state, action) => rootDuckReducer(state, action);

export default createReducer;
